module.exports = __webpack_public_path__ + "img/NavaRatri_2022.5bf4db64.jpg";